<template>
  <b-form-group :key="identifier" v-if="domanda">
    <template v-if="domanda.o === 'file'">
      <SurveyUploader
        v-on:upload-result="handleUpload"
        v-on:remove-result="removeUpload"
        :accepts="domanda.fa"
        :isMulti="domanda.fm"
      />
    </template>
    <template v-else-if="domanda.cb && Array.isArray(domanda.o)">
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{ required: isRequired }"
      >
        <b-form-checkbox-group
          :name="'q_' + index"
          v-model="domanda.a"
          :options="domanda.o"
          :state="v.errors[0] ? false : null"
        ></b-form-checkbox-group>
        <span class="text-danger">{{ messaggioErrore(v) }}</span>
      </ValidationProvider>
    </template>
    <template v-else-if="Array.isArray(domanda.o) && !tipo">
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{ required: isRequired }"
      >
        <template v-if="useLegacyButtons">
          <SurveyRadioButtonGroup v-model="domanda.a" :options="domanda.o" />
          <input type="hidden" :value="domanda.a" :name="'q_' + index" />
        </template>
        <b-form-select
          v-else
          v-capitalize-first-select
          class="px-3 align-self-center"
          v-model="domanda.a"
          :name="'q_' + index"
          :state="v.errors[0] ? false : null"
        >
          <b-form-select-option v-for="opt in domanda.o" :key="opt" :value="opt"
            >{{ opt }}
          </b-form-select-option>
        </b-form-select>
        <span class="text-danger">{{ messaggioErrore(v) }}</span>
      </ValidationProvider>
    </template>
    <template
      v-else-if="(tipo == null && !domanda.cb) || tipo === 'text'"
    >
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{
          required: isRequired,
          min: domanda.rc && domanda.rc.min ? domanda.rc.min : null,
          max: domanda.rc && domanda.rc.max ? domanda.rc.max : 99999,
        }"
      >
        <b-form-textarea
          v-if="defaultInputType === 'textarea' && tipo == null"
          v-capitalize-first
          class="my-2 col-10 mx-auto"
          placeholder="..."
          :name="'q_' + index"
          v-model="domanda.a"
          :state="v.errors[0] ? false : null"
          rows="3"
        ></b-form-textarea>
        <b-form-input
          v-else
          v-capitalize-first
          class="align-self-center"
          placeholder="..."
          type="text"
          :name="'q_' + index"
          v-model="domanda.a"
          :state="v.errors[0] ? false : null"
        ></b-form-input>
        <span class="text-danger">{{ messaggioErrore(v) }}</span>
      </ValidationProvider>
    </template>
    <template v-else-if="domanda.t === 'number'">
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{
          required: isRequired,
          min_value: domanda.rc && domanda.rc.min ? domanda.rc.min : null,
          max_value:
            domanda.rc && domanda.rc.max ? domanda.rc.max : 9999999999999999,
        }"
      >
        <b-form-input
          v-capitalize-first
          class="align-self-center"
          placeholder="..."
          type="number"
          :name="'q_' + index"
          v-model="domanda.a"
          :state="v.errors[0] ? false : null"
        ></b-form-input>
        <span class="text-danger">{{ messaggioErrore(v) }}</span>
      </ValidationProvider>
    </template>
    <template v-else-if="domanda.t === 'slider'">
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{
          required: isRequired,
          min_value: domanda.rc && domanda.rc.min != null ? domanda.rc.min : null,
          max_value:
            domanda.rc && domanda.rc.max != null ? domanda.rc.max : 9999999999999999,
        }"
      >
        <!-- Indicazione discreta su come muovere il selettore: utile ai pazienti meno
             pratici, che potrebbero non riconoscere il cursore come trascinabile -->
        <div class="d-flex justify-content-end align-items-center mb-1">
          <b-icon
            icon="info-circle"
            class="text-secondary mr-1"
            role="img"
            tabindex="0"
            :aria-label="$t('SurveyQuestionInput.aiuto_slider_label')"
            v-b-popover.hover.focus.top="{
              title: $t('SurveyQuestionInput.aiuto_slider_titolo'),
              content: $t('SurveyQuestionInput.aiuto_slider_testo'),
            }"
          ></b-icon>
          <small class="text-secondary">{{
            $t("SurveyQuestionInput.aiuto_slider")
          }}</small>
        </div>
        <SurveySliderInput
          v-model="domanda.a"
          :rc="domanda.rc"
          :name="'q_' + index"
          :aria-label="domanda.q"
          :state="v.errors[0] ? false : null"
        />
        <span class="text-danger">{{ messaggioErrore(v) }}</span>
      </ValidationProvider>
    </template>
    <template v-else-if="domanda.t === 'select'">
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{ required: isRequired }"
      >
        <b-form-select
          v-capitalize-first-select
          class="px-3 align-self-center"
          v-model="domanda.a"
          :name="'q_' + index"
          :state="v.errors[0] ? false : null"
        >
          <b-form-select-option v-for="opt in domanda.o" :key="opt" :value="opt"
            >{{ opt }}
          </b-form-select-option>
        </b-form-select>
        <span class="text-danger">{{ messaggioErrore(v) }}</span>
      </ValidationProvider>
    </template>
    <template v-else-if="domanda.t === 'radio'">
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{ required: isRequired }"
      >
        <SurveyRadioButtonGroup v-model="domanda.a" :options="domanda.o" />
        <input type="hidden" :value="domanda.a" :name="'q_' + index" />
        <span class="text-danger">{{ messaggioErrore(v) }}</span>
      </ValidationProvider>
    </template>
    <template v-else-if="domanda.t === 'select-multi'">
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{ required: isRequired }"
      >
        <b-form-tags
          :name="'q_' + index"
          v-model="domanda.a"
          size="lg"
          class="mb-2"
          add-on-change
          no-outer-focus
          :state="v.errors[0] ? false : null"
          @focus="hasFocus = index"
          @focusin="hasFocus = index"
        >
          <template
            v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }"
          >
            <b-form-select
              v-capitalize-first-select
              v-bind="inputAttrs"
              v-on="inputHandlers"
              :disabled="disabled || domanda.o.length === 0"
              :options="domanda.o"
            >
              <template #first>
                <option disabled value="">scegli una o più opzioni...</option>
              </template>
            </b-form-select>
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mt-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag
                  @remove="removeTag(tag)"
                  :title="tag"
                  :disabled="disabled"
                  variant="secondary"
                  >{{ tag }}</b-form-tag
                >
              </li>
            </ul>
          </template>
        </b-form-tags>
        <span class="text-danger">{{ messaggioErrore(v) }}</span>

        <template
          v-if="Array.isArray(domanda.a) && domanda.a.includes('altro')"
        >
          <b-input-group v-if="hasFocus === index">
            <b-form-input
              v-capitalize-first
              class="align-self-center input_with_append"
              placeholder="altra opzione personalizzata"
              type="text"
              :name="'qti_' + index"
              v-model="tempTag"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="addCustom">Aggiungi altro</b-button>
            </b-input-group-append>
          </b-input-group>
        </template>
      </ValidationProvider>
    </template>
    <template v-else-if="domanda.t === 'date'">
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{
          required: isRequired,
          minDate: validMinDate,
          maxDate: validMaxDate,
        }"
      >
        <b-form-input
          class="align-self-center"
          placeholder="GG/MM/AAAA"
          type="date"
          :name="'q_' + index"
          v-model="domanda.a"
          :state="v.errors[0] ? false : null"
          :min="validMinDate"
          :max="validMaxDate"
        ></b-form-input>
        <span class="text-danger">{{ messaggioErrore(v) }}</span>
      </ValidationProvider>
    </template>
    <template v-else-if="domanda.t === 'time'">
      <ValidationProvider
        :name="$t('SurveyQuestionInput.campo_risposta')"
        :vid="'q_' + index"
        v-slot="v"
        :rules="{
          required: isRequired,
          minDate: validMinHour,
          maxDate: validMaxHour,
        }"
      >
        <b-form-input
          class="align-self-center"
          placeholder="hh:mm"
          type="time"
          :name="'q_' + index"
          v-model="domanda.a"
          :state="v.errors[0] ? false : null"
          :min="validMinHour"
          :max="validMaxHour"
        ></b-form-input>
        <span class="text-danger">{{ messaggioErrore(v) }}</span>
      </ValidationProvider>
    </template>
    <ValidationProvider
      v-else-if="domanda.t === 'textarea'"
      :name="$t('SurveyQuestionInput.campo_risposta')"
      :vid="'q_' + index"
      v-slot="v"
      :rules="{ required: isRequired }"
    >
      <b-textarea
        class="shadow_6"
        :name="'q_' + index"
        v-model="domanda.a"
        :state="v.errors[0] ? false : null"
        rows="3"
      ></b-textarea>
      <span class="text-danger">{{ messaggioErrore(v) }}</span>
    </ValidationProvider>
  </b-form-group>
</template>
<script>
import * as moment from "moment/moment";
import { Validator, ValidationProvider } from "vee-validate";
import SurveyUploader from "@/app/common/components/utilities/SurveyUploader.vue";
import SurveyRadioButtonGroup from "@/app/common/components/utilities/SurveyRadioButtonGroup.vue";
import SurveySliderInput from "@/app/common/components/utilities/SurveySliderInput.vue";
import * as surveyFlow from "@/_utils/survey_flow";

export default {
  name: "SurveyQuestionInput",
  components: {
    SurveyUploader,
    SurveyRadioButtonGroup,
    SurveySliderInput,
    ValidationProvider,
  },
  props: {
    identifier: {
      type: String,
      default: "id",
    },
    index: {
      type: Number,
      default: 0,
    },
    question: {
      type: Object,
      default: () => ({
        a: null,
        k: null,
        o: null,
        q: "question",
        r: true,
        t: "text",
        v: false,
        bn: 1,
        cb: false,
        rc: null,
        ric: null,
        insert: null,
        dataInsert: false,
        si: null,
      }),
    },
    isRequiredAnswer: {
      default: null,
    },
    legacyOptionsMode: {
      type: String,
      default: "select",
    },
    defaultInputType: {
      type: String,
      default: "text",
    },
  },
  computed: {
    // Il tipo della domanda. Le schede di anamnesi del teleconsulto rapido e
    // pediatrico (seeder dell'API) salvano "t": "null" come testo: nessun
    // ramo lo riconosceva e la domanda restava senza campo, quindi il
    // questionario non si poteva compilare né inviare. Vale come tipo assente,
    // cioè testo libero, come faceva il vecchio FillSurvey.
    tipo() {
      const t = this.domanda ? this.domanda.t : null;
      return t === "null" ? null : t;
    },
    isRequired() {
      if (this.isRequiredAnswer !== null) {
        return this.isRequiredAnswer;
      }
      return this.domanda.r !== undefined
        ? this.domanda.r && !this.domanda.ric
        : true;
    },
    useLegacyButtons() {
      return (
        this.legacyOptionsMode === "buttons" &&
        surveyFlow.shouldUseOptionButtons(this.domanda)
      );
    },
    validMinDate() {
      if (this.domanda.rc) {
        if (this.domanda.rc.minExact) {
          return this.domanda.rc.minExact;
        }
        if (
          this.domanda.rc.minDate &&
          (this.domanda.rc.minDate.y ||
            this.domanda.rc.minDate.m ||
            this.domanda.rc.minDate.d)
        ) {
          var mindate = moment();
          if (this.domanda.rc.minDate.y) {
            mindate.subtract(this.domanda.rc.minDate.y, "years");
          }
          if (this.domanda.rc.minDate.m) {
            mindate.subtract(this.domanda.rc.minDate.m, "months");
          }
          if (this.domanda.rc.minDate.d) {
            mindate.subtract(this.domanda.rc.minDate.d, "days");
          }
          return mindate.format("YYYY-MM-DD");
        }
      }
      return null;
    },
    validMaxDate() {
      if (this.domanda.rc) {
        if (this.domanda.rc.maxExact) {
          return this.domanda.rc.maxExact;
        }
        if (
          this.domanda.rc.maxDate &&
          (this.domanda.rc.maxDate.y ||
            this.domanda.rc.maxDate.m ||
            this.domanda.rc.maxDate.d)
        ) {
          var maxdate = moment();
          if (this.domanda.rc.maxDate.y) {
            maxdate.add(this.domanda.rc.maxDate.y, "years");
          }
          if (this.domanda.rc.maxDate.m) {
            maxdate.add(this.domanda.rc.maxDate.m, "months");
          }
          if (this.domanda.rc.maxDate.d) {
            maxdate.add(this.domanda.rc.maxDate.d, "days");
          }
          return maxdate.format("YYYY-MM-DD");
        }
      }
      return "2100-12-31";
    },
    validMinHour() {
      if (this.domanda.rc) {
        if (this.domanda.rc.minExact) {
          return this.domanda.rc.minExact;
        }
        if (
          this.domanda.rc.minTime &&
          (this.domanda.rc.minTime.h || this.domanda.rc.minTime.m)
        ) {
          var mintime = moment();
          if (this.domanda.rc.minTime.h) {
            mintime.subtract(this.domanda.rc.minTime.h, "hours");
          }
          if (this.domanda.rc.minTime.m) {
            mintime.subtract(this.domanda.rc.minTime.m, "minutes");
          }
          return mintime.format("HH:mm");
        }
      }
      return null;
    },
    validMaxHour() {
      if (this.domanda.rc) {
        if (this.domanda.rc.maxExact) {
          return this.domanda.rc.maxExact;
        }
        if (
          this.domanda.rc.maxTime &&
          (this.domanda.rc.maxTime.h || this.domanda.rc.maxTime.m)
        ) {
          var maxtime = moment();
          if (this.domanda.rc.maxTime.h) {
            maxtime.add(this.domanda.rc.maxTime.h, "hours");
          }
          if (this.domanda.rc.maxTime.m) {
            maxtime.add(this.domanda.rc.maxTime.m, "minutes");
          }
          return maxtime.format("HH:mm");
        }
      }
      return "23:59";
    },
  },
  data() {
    return {
      domanda: null,
      hasFocus: null,
      tempTag: null,
    };
  },
  watch: {
    question: function (value) {
      if (value) {
        this.domanda = value;
        this.normalizeAnswer();
      }
    },
    "domanda.a": function (value) {
      if (value !== undefined) {
        this.$nextTick(function () {
          this.$emit("question-response", value);
        });
      }
    },
  },
  methods: {
    // Messaggio di errore mostrato sotto la domanda: per l'obbligatorieta' usiamo un testo
    // unico e neutro, mentre per le altre regole (min/max, date, ecc.) lasciamo il messaggio
    // specifico di vee-validate.
    messaggioErrore(v) {
      if (v.failedRules && v.failedRules.required) {
        return this.$t("SurveyQuestionInput.campo_obbligatorio");
      }
      return v.errors[0];
    },
    normalizeAnswer() {
      if (!this.domanda) {
        return;
      }
      if (this.domanda.cb || this.domanda.t === "select-multi") {
        this.$set(
          this.domanda,
          "a",
          surveyFlow.normalizeMultipleAnswer(this.domanda)
        );
      }
    },
    addCustom() {
      if (!Array.isArray(this.domanda.a)) {
        this.$set(this.domanda, "a", []);
      }
      if (this.tempTag) {
        this.domanda.a.push(this.tempTag);
      }
      this.tempTag = null;
      this.$nextTick(function () {
        this.$emit("question-response", this.domanda.a);
      });
    },
    handleUpload(data) {
      if (Array.isArray(data)) {
        this.$set(
          this.domanda,
          "a",
          data.map((el) => el.hashid)
        );
      } else {
        if (this.domanda.a == null) {
          this.$set(this.domanda, "a", []);
        }
        this.domanda.a.push(data.hashid);
      }
      this.$emit("question-response", this.domanda.a);
    },
    removeUpload() {
      this.$set(this.domanda, "a", null);
      this.$emit("question-response", this.domanda.a);
    },
  },
  created() {
    this.domanda = this.question;
    this.normalizeAnswer();
    const minDateFn = (value, [min]) => {
      return min !== null ? value >= min : true;
    };
    const maxDateFn = (value, [max]) => {
      return max !== null ? value <= max : true;
    };
    Validator.extend("minDate", minDateFn, ["min"]);
    Validator.extend("maxDate", maxDateFn, ["max"]);
  },
};
</script>
